
import { Vue, Component } from "vue-property-decorator";

@Component({})
export default class _404 extends Vue {

}
